export default __webpack_public_path__ + "static/media/6.3bd2a305.png";